import { render, staticRenderFns } from "./CogsDefinition.vue?vue&type=template&id=03e2cd75&scoped=true&"
import script from "./CogsDefinition.vue?vue&type=script&lang=ts&"
export * from "./CogsDefinition.vue?vue&type=script&lang=ts&"
import style0 from "./CogsDefinition.vue?vue&type=style&index=0&id=03e2cd75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e2cd75",
  null
  
)

export default component.exports